import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"400px"}
}
const _hoisted_4 = { class: "modal__content pa-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Please enter the one time password to verify your account", -1)
const _hoisted_6 = { class: "ma--bottom-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "display--flex align--center" }
const _hoisted_9 = { class: "form-field__outline--control" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn--primary ma--left-1",
  type: "submit"
}, "Validate", -1)
const _hoisted_11 = { class: "text--align-center ma--top-2" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_outline = _resolveDirective("outline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, "A code has been sent to " + _toDisplayString(_ctx.phoneNo), 1),
        (!_ctx.resendOTP)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.seconds) + " seconds remaining to resend OTP", 1))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.verifyOTP && _ctx.verifyOTP(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-field form-field__outline ma-0", { 
                                'form-field__outline--invalid': _ctx.v$.request.otp.$error,
                                'form-field__outline--active': !_ctx.v$.request.otp.$invalid 
                            }]),
              style: {"width":"75%"}
            }, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-field__outline--control__input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.otp) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.request.otp],
                  [_directive_outline]
                ])
              ])
            ], 2),
            _hoisted_10
          ])
        ], 32),
        _createElementVNode("p", _hoisted_11, [
          _createTextVNode("Didn't get code? "),
          _createElementVNode("button", {
            class: "resend",
            disabled: !_ctx.resendOTP,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resend && _ctx.resend(...args)))
          }, " Resend ", 8, _hoisted_12)
        ])
      ])
    ])
  ]))
}